import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from "@angular/forms";
import { IonicPageModule } from 'ionic-angular';
import { LoginPage } from './login';

@NgModule({
  declarations: [
    LoginPage,
  ],
  imports: [
    IonicPageModule.forChild(LoginPage),
    ReactiveFormsModule,
  ],
  exports: [
    LoginPage
  ]
})
export class LoginPageModule {}


// WEBPACK FOOTER //
// ./src/pages/login/login.module.ts